import React, { useState } from 'react';
import { DisplayValue } from '../Models/Valg';
import Valg from '../Models/Valg';

interface SelectOptionsDisplayProps {
    htmlId: any,
    options: DisplayValue[],
    ledetekst: any,
    onSelectChange: any,
    showSearch?: boolean,
    value?: Valg<string>,
    buttonProps?: React.HTMLAttributes<HTMLButtonElement>;
}

export default function SelectOptionDisplay (props: SelectOptionsDisplayProps): JSX.Element {
    let items = [];
    let filteredOptions: DisplayValue[] = [];
    let searchEl: JSX.Element | null = null;
    const [filteredText, setFilteredText] = useState('');
    const [aktivNedtrekk, setAktivNedtrekk] = useState('');
    const [aktivKnapp, setAktivKnapp] = useState('');

    function fokusSokHandler() : void {
        setAktivKnapp("ekspandert-nedtrekk");
        setAktivNedtrekk("open-list");
    }

    function searchHandler(e: React.SyntheticEvent<HTMLInputElement>) : void {
        setFilteredText(e.currentTarget.value);
    }

    function openListHandler (e: React.SyntheticEvent<HTMLButtonElement>) : void{
        if(aktivNedtrekk === '') {
            setAktivKnapp("ekspandert-nedtrekk");
            setAktivNedtrekk("open-list");
        } else {
            setAktivKnapp('');
            setAktivNedtrekk('');
        }
    }

    function selectItemHandler (e: React.SyntheticEvent<HTMLDivElement>) : void {
        setAktivKnapp('');
        setAktivNedtrekk('');
        resetFilter();

        if(e.currentTarget.textContent === null)
            e.currentTarget.textContent = "";

        let id: string | null = e.currentTarget.getAttribute("data-value");
        if(id === null)
            id = "";

        let valg: Valg<string> = { id: id, displayValue: e.currentTarget.textContent, value: ""}
        props.onSelectChange(valg);
    }

    function resetFilter(): void {
        if(props.showSearch)
        {
            setFilteredText('');
        }
    }

    function buttonKeyDownHandler(e: React.KeyboardEvent<HTMLButtonElement>) : void {
        //escape
        if(e.key === 'Escape') {
            setAktivKnapp('');
            setAktivNedtrekk('');
        }

        //arrow down
        if(e.key === 'ArrowDown') {
            setAktivKnapp("ekspandert-nedtrekk");
            setAktivNedtrekk("open-list");
            
            if(props.showSearch) {
                document.getElementById(props.htmlId + '-sokfilter')?.querySelector("input")?.focus();
            } else {
                document.getElementById(props.htmlId)?.querySelector("div")?.focus();
            }
        }
    }

    function itemKeyDownHandler(e: React.KeyboardEvent<HTMLDivElement>) : void {
        if(e.key === 'ArrowDown') {
            (e.currentTarget?.nextSibling as HTMLElement)?.focus();
        }
        
        if(e.key === 'ArrowUp') {
            (e.currentTarget?.previousSibling as HTMLElement)?.focus();
        }

        if(e.key === 'Enter') {
            selectItemHandler(e);
        }
    }

    function filterKeyDownHandler(e: React.KeyboardEvent<HTMLInputElement>) : void {
        if(e.key === 'ArrowDown') {
            document.getElementById(props.htmlId)?.querySelector("div")?.focus();
        }
    }
    
    if(filteredText === null || filteredText === undefined || filteredText === '') {
        filteredOptions = props.options;
    } else {
        filteredOptions = props.options.filter(x => x.displayValue.toLowerCase().indexOf(filteredText.toLowerCase()) > -1);
    }

    for(let i = 0;i<filteredOptions.length;i++) 
    {
        items.push(<div tabIndex={0} onKeyDown={itemKeyDownHandler} onClick={selectItemHandler} role="option" className="c-select-options-option" key={i} data-value={filteredOptions[i].id}>{filteredOptions[i].displayValue}</div>)
    }

    if(props.showSearch) {
        searchEl = <div id={props.htmlId + '-sokfilter'} className={'c-select-options-search ' + aktivNedtrekk}>
            <input value={filteredText} id={props.htmlId + '-sokfilterInput'} onKeyDown={filterKeyDownHandler} placeholder="Filtrer liste" type="text" onFocus={fokusSokHandler} onChange={searchHandler} className="c-select-options-search__input" />
        </div>;
    }

    return (
        <div>
            <div id={props.htmlId + '-c-select-options__ledetekst'} className="c-select-options__ledetekst">{props.ledetekst}</div>
            <div className="c-select-option-alt">
                <button
                    {...(props.buttonProps ?? {})}
                    aria-labelledby={props.htmlId + '-c-select-options__ledetekst'}
                    onKeyDown={buttonKeyDownHandler}
                    className={aktivKnapp}
                    aria-haspopup="listbox"
                    onClick={openListHandler}
                >
                    <span className="c-select-options__button--text">{props.value?.displayValue}</span>
                    <span id={props.htmlId + '-c-select-options__button'} className="c-select-options__button--arrow"></span>
                </button>
                {searchEl}
                <div id={props.htmlId} role="listbox" aria-labelledby={`${props.htmlId}-c-select-options__ledetekst`} className={'c-select-options-container js-select-options-container ' + aktivNedtrekk}>
                    {items}
                </div>
            </div>
        </div>
    );
}